import styled from 'styled-components';
import { Colors } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  color: ${Colors.GS100};
  font-weight: 600;
  line-height: ${({ $size }) => ($size === 'small' ? '130%' : '150%')};
  letter-spacing: ${({ $size }) => ($size === 'small' ? '0.24px' : '0.14px')};
  background-color: ${Colors.G350};
  border-radius: 4px;
  padding: 3px 10px;
  font-size: ${({ $size }) => ($size === 'small' ? '12px' : '14px')};
  width: fit-content;
`;
